<template>
  <component
    :v-bind="$attrs"
    :is="buttonOrLink"
    :href="href"
    class="cm-button"
    :class="{
      [size]: true,
      [width]: true,
      light
    }"
  >
    <slot />
  </component>
</template>

<script>
export default {
  name: "CMButton",
  props: {
    href: { type: String },
    to: { type: String },
    size: { type: String, default: 'medium' },
    width: { type: String, default: 'narrow' },
  },
  computed: {
    buttonOrLink () {
      if (!!this.href) return "a"
      if (!!this.to) return "router-link"
      return "button"
    }
  }
}
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// app/javascript/components/cm-button.vue?3f9fd5da